
import request from '@/http'
const url = process.env.VUE_APP_APIMACHINERY
const apiTalents = {// 人才
  categoryList: () => request.get('/api/sysTalentCategory/categoryList'),
  getTalent: (params, data) => request.postParamsData('/search/getTalent', params, data)
}
const apiTeam = { // 工队
  // 分类列表
  findCategoryListTree: (data) => request.get('/api/sysTeamCategory/findCategoryListTree', data),
  // 获取工队列表
  getTeam: (params, data) => request.postParamsData('/search/getTeam', params, data),
  // search/getTeam
}
const apiEnterprise = { // 劳务公司
  getCompany: (params, data) => request.postParamsData('/search/getCompany', params, data),
  getLabourList: params => request.get('/api/companyTemp/getLabourList', params)
}
// 专业技能
const getProfessionalSkill = {
  getlist: () => request.get(`/sysTalentCategory/findCategoryListTree`),
  getArea: (data) => request.get(url + `/api/sysMachineryBasicArea/getSimpleAreaList`, data)
}
const getHotJobsData = {
  // 所属行业
  getlist: () => request.get(`/sysTalentCategory/findCategoryListTree`),
  // 获取工作经验
  getWorkExperienceFun: () => request.get(`/talent/workList`),
  // 获取学历
  getEducationBackgroundFun: () => request.get(`/talent/educationList/`),
  // 获取薪资
  getCompensationFun: () => request.get(`/talent/salaryList/`),
  // 获取热门职位列表
  getTalentRecruit: (params, data) => request.get(`/search/getTalentRecruit`, params, data)
}
const getRecruitmentTeamListData = {
  // 获取热门职位列表
  getRecruitmentTeamList: (params, data) => request.post(`/api/teamRecruit/list`, params, data)
}
// 专业技能
// export const getProfessionalSkill = async (params) => request.get(`${url}/sysCertificateConfig/getConfigList`, params)
const apiPublic = {
  getAreaSecond: () => request.get('/api/index/getAreaSecond')
}
export { apiTalents, apiTeam, apiEnterprise, apiPublic, getProfessionalSkill, getHotJobsData, getRecruitmentTeamListData }
